import Swiper from 'swiper';

const TeamSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.team-slider__carousel');
        if (!carousels.length) return;

        carousels.forEach((carousel) => {
            const swiper = new Swiper(carousel, {
                slidesPerView: 1,
                spaceBetween: 40,
                centeredSlides: false,
                loop: false,
                autoplay: true,
                breakpoints: {
                    1024: {
                        slidesPerView: 4.2,
                        slidesOffsetAfter: 200,
                    },
                    1180: {
                        centeredSlides: false,
                        slidesPerView: 4.2,
                        spaceBetween: 20,
                        slidesOffsetAfter: 200,
                    },
                    1440: {
                        centeredSlides: false,
                        slidesPerView: 4.2,
                        slidesOffsetAfter: 200,
                    }
                }
            });

            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');

            const updateButtonStates = () => {
                prevButton.disabled = swiper.isBeginning;
                nextButton.disabled = swiper.isEnd;

                prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
            };

            prevButton.addEventListener('click', () => {
                swiper.slidePrev();
            });

            nextButton.addEventListener('click', () => {
                swiper.slideNext();
            });

            // Update button states initially and after each slide change
            updateButtonStates();
            swiper.on('slideChange', updateButtonStates);
        });
    }

    return {
        init
    }
}

export default TeamSlider;